import styled, { css } from 'styled-components'

import Icon from 'components/icons'
import mediaQueries from 'components/media-queries'
import { common } from 'constants/e2eClasses'

export const Container = styled.div.attrs(() => ({
  className: common.tabBox
}))`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const TabBar = styled.div.attrs(() => ({
  className: common.tabBar
}))`
  display: flex;
  flex-direction: row;
  width: 100%;
`

export const Indicator = styled.div`
  width: 100%;
  height: 3px;
  margin: -1px auto 0;

  ${props =>
    props.selected &&
    css`
      background-color: ${({ theme }) => theme.colors.blue};
    `};

  ${({ bookingTabs }) =>
    bookingTabs &&
    css`
      width: 70%;
      ${mediaQueries.mobile`
          width: 100%;
        `};
    `};
`

export const TabContainer = styled.div.attrs(() => ({
  className: common.tab
}))`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  margin-right: 20px;

  ${({ disabled, bookingTabs }) =>
    !disabled &&
    !bookingTabs &&
    css`
      &:hover > ${Indicator} {
        background-color: ${({ theme }) => theme.colors.blue};
      }
    `};

  &:last-child {
    margin-right: 0;
  }

  ${({ bookingTabs }) =>
    bookingTabs &&
    css`
      width: 18%;
      margin-right: 2px;
      align-items: center;

      ${mediaQueries.tablet`
        width: 150px;
      `};
    `};
`

export const Tab = styled.button`
  border: none;
  color: ${({ theme }) => theme.colors.doveGray};
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  border-radius: 3px;
  cursor: pointer;
  text-align: center;
  width: 100%;
  justify-content: center;

  ${({ selected }) =>
    selected &&
    css`
      color: ${({ theme }) => theme.colors.blue};
      background-color: ${({ theme }) => theme.colors.white};
    `};

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: default;
      background-color: ${({ theme }) => theme.colors.gray10};
    `};

  ${({ bookingTabs }) =>
    bookingTabs &&
    css`
      background-color: ${({ theme }) => theme.colors.grayLighter};
      ${({ selected }) =>
        selected &&
        css`
          color: ${({ theme }) => theme.colors.blue};
          background-color: ${({ theme }) => theme.colors.white};
        `};
    `};
`

export const TabPanel = styled.div.attrs(() => ({
  className: common.tabPanel
}))`
  width: 100%;
`

export const StyledIcon = styled(Icon)`
  ${mediaQueries.mobile`
    margin: 10px;
  `};
`
